import { Box, Button, Chip, Grid, Link } from '@mui/material'
import {
  CheckCircleOutlineIcon,
  CloseIcon,
  DragIndicatorIcon,
  HomeIcon,
  PhoneIcon,
  PhoneIphoneIcon,
  WorkIcon,
} from 'components/Icons'
import { useTranslation } from 'react-i18next'
import FieldSkeleton from './FieldSkeleton'

const phoneIcon = phone =>
  phone?.type === 'home' ? (
    <HomeIcon />
  ) : phone?.type === 'mobile' ? (
    <PhoneIphoneIcon />
  ) : phone?.type === 'work' ? (
    <WorkIcon />
  ) : (
    <PhoneIcon />
  )

export default function AdditionalContactItem({
  item,
  index,
  itemCount,
  onEdit,
  setMovedItemData,
}) {
  const { t } = useTranslation()
  const draggable = itemCount > 1

  return (
    <Box
      flexDirection="row"
      sx={{ pb: 1, height: '60px' }}
      draggable={draggable}
      onDragStart={() => setMovedItemData(index, -1, false, true, item.id)}
      onDragOver={e => {
        e.preventDefault()
        setMovedItemData(-1, index, false, true, item.id)
      }}
      onDragEnd={e => {
        e.preventDefault()
        setMovedItemData(-1, -1, true, false, item.id)
      }}
    >
      <Grid container spacing={2}>
        {draggable && (
          <Grid item xs={1} >
            <Box sx={{ cursor: 'move' }}>
              <DragIndicatorIcon />
            </Box>
          </Grid>
        )}

        <Grid item xs={2}>
          {item.relationship?.slice(0, 1).toUpperCase()}
          {item.relationship?.slice(1)}
        </Grid>

        <Grid item xs={2}>
          <Link
            component="button"
            type="button"
            underline="hover"
            color="inherit"
            onClick={() => onEdit(item)}
          >
            {[item.contact?.title, item.contact?.firstName, item.contact?.middleName, item.contact?.lastName]
              .filter(Boolean)
              .join(' ')}
          </Link>
        </Grid>

        <Grid item xs={2} >
          {item.contact?.phones?.[0]?.number ? (
            <Chip icon={phoneIcon(item.contact.phones[0])} label={item.contact.phones[0].number} />
          ) : (
            <FieldSkeleton />
          )}
        </Grid>

        <Grid item xs={2} >
          <Chip
            icon={item.pickup ? <CheckCircleOutlineIcon /> : <CloseIcon />}
            label={t('Pickup')}
            color={item.pickup ? 'success' : 'error'}
          />
        </Grid>

        <Grid item xs={2} >
          <Chip
            icon={item.emergency ? <CheckCircleOutlineIcon /> : <CloseIcon />}
            label={t('Emergency Call')}
            color={item.emergency ? 'success' : 'error'}
          />
        </Grid>

        <Grid item sx={{ textAlign: 'right' }} xs={ draggable ? 1 : 2}>
          <Button color="primary" size="small" variant="outlined" onClick={() => onEdit(item)}>
            {t('Edit')}
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}
